export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8112.8c9d65b9.jpg";